import styles from "../styles/Contact.module.css";
import ContactForm from "../components/ContactForm/ContactForm";

export default function Contact() {
    return    <>
    <section className={styles.heroContainer}>
        <div className={styles.overlay}>
            <h1 className={styles.title}>Kontakt</h1>
        </div>
    </section>
        <div>
            <ContactForm/>
        </div>
    </>;
}